module.exports = __webpack_public_path__ + "static/media/boomer_start.185e8088.png";